module.exports = __webpack_public_path__ + "static/img/newanli-07.804987a2.png";